import EntityType from 'txp-data/lib/schema/innerSchema/EntityType';

export default function convertEntityTypeToEventFlag(entityType: EntityType) {
    switch (entityType) {
        case EntityType.FlightReservation:
            return 'FlightReservation';
        case EntityType.LodgingReservation:
            return 'LodgingReservation';
        case EntityType.RentalCarReservation:
            return 'RentalCarReservation';
        case EntityType.ParcelDelivery:
            return 'ParcelDelivery';
        case EntityType.FoodReservation:
            return 'FoodEstablishmentReservation';
        case EntityType.EventReservation:
            return 'EventReservation';
        case EntityType.Invoice:
            return 'Invoice';
        case EntityType.ServiceReservation:
            return 'ServiceReservation';
        default:
            return '';
    }
}
